<template>
  <div class="home">
    <div class="container">
      <div class="grid">
        <div class="card">
          <img src="@/assets/tudobem.png" alt="Vai ficar tudo bem?" />
        </div>

        <div class="card">
          <h1 class="text-left pb-2">
            Por que Programador (ou desenvolvedor) não podem ser MEI?
          </h1>
          <div
            class="text-left pb-2"
            style="margin-top:6px;font-weight:500;font-size:14px;"
          >
            Primeiramente precisamos destacar para quem realmente o MEI foi
            criado.<br /><br />
            O MEI foi criado para profissionais autônomos informais que têm
            atividades que não são de cunho intelectual e científico.<br /><br />
            Por exemplo as atividades de pedreiro, pipoqueiro, barbeiro
            independente, diarista, dentre muitas outras pois a lista é grande.
            <br /><br />

            Portanto as atividades de cunho científico e intelectual não fazem
            parte da lista de CNAEs (Classificação Nacional de Atividades
            Econômicas) permitidas para o MEI.<br /><br />

            E por isso que os CNAEs de programação não fazem parte das
            atividades permitidas para o MEI.<br /><br />

            E sendo assim você que é programador/desenvolvedor não pode ser MEI.
          </div>
          <h2 class="text-left pb-2">Disclaimer</h2>
          <div
            class="text-left pb-2"
            style="margin-top:6px;font-weight:500;font-size:14px;"
          >
            Pense muito bem antes de optar pelo MEI, pois sua atividade como
            programador não se enquadra como MEI.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
};
</script>
